<div class="container-fluid font-responsive" [ngClass]="{'p-0': mobileMode, 'h-100': mobileMode}"
  style="position: relative" [style.background-color]="clozeTestStyleModel.siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{'h-100': mobileMode}">
    <div class="card" [ngClass]="{'container-fluid': mobileMode, 'p-0': mobileMode}" style="min-height: 570px;"
      [style.background-color]="clozeTestStyleModel.exerciseBackground"
      [ngStyle]="{'border': mobileMode ? '0px' : '1px solid ' + clozeTestStyleModel.frameColor, 'border-radius': mobileMode? '0px' : '0.25rem', 'width': mobileMode? '' : '720px'}">
      <div class="card-body" [ngClass]="{'card-mobile': mobileMode }" [style.font-family]="clozeTestStyleModel.font"
        [style.font-size]="clozeTestStyleModel.fontSize" style="overflow-y: scroll;">
        <div>
          <img style="height: 30px;" src="onset-assets/img/onset_logo.png">
          <img style="height: 40px;" class="ml-4" src="onset-assets/img/icon_ger_onset.svg">
        </div>
        <h5 class="card-title font-weight-bold mt-4" style="font-size: 1rem!important;">{{'GAST-ONSET-NG.GER_INFO.TITLE' | translate}}</h5>
        <p>
          {{'GAST-ONSET-NG.GER_INFO.DESC_1' | translate}}
        </p>

        <p>
          {{'GAST-ONSET-NG.GER_INFO.DESC_2' | translate}}
        </p>

        <!-- <div>
          <table>
            <tr>
              <td colspan="2" class="table-header">Gemeinsamer europäischer Referenzrahmen für Sprachen (GER)</td>
            </tr>
            <tr>
              <td class="grey-bg" colspan="2"><span class="font-weight-bold">A</span> Basic User Elementare
                Sprachverwendung</td>
            </tr>
            <tr>
              <td class="grey-bg"><span class="font-weight-bold">A1</span> Breakthrough</td>
              <td><span class="font-weight-bold">A2</span> Waystage</td>
            </tr>
            <tr>
              <td class="grey-bg" colspan="2"><span class="font-weight-bold">B</span> Independent User Selbstständige
                Sprachverwendung</td>
            </tr>
            <tr>
              <td><span class="font-weight-bold">B1</span> Threshold</td>
              <td><span class="font-weight-bold">B2</span> Vantage</td>
            </tr>
            <tr>
              <td class="grey-bg" colspan="2"><span class="font-weight-bold">C</span> Proficient User Kompetente
                Sprachverwendung</td>
            </tr>
            <tr>
              <td><span class="font-weight-bold">C1</span> Effective Proficiency</td>
              <td class="grey-bg"><span class="font-weight-bold">C2</span> Mastery</td>
            </tr>
          </table>
        </div> -->

        <img style="height: 60%;" src="onset-assets/img/GER_onSET_mobil.svg">

        <p class="mt-4">
          {{'GAST-ONSET-NG.GER_INFO.DESC_3' | translate}}
        </p>

        <span><a style="text-decoration: underline;" href="https://www.onset.de/">{{'GAST-ONSET-NG.GER_INFO.BACK' | translate}}</a>{{'GAST-ONSET-NG.GER_INFO.TO_ONSET' | translate}}</span>
      </div>
    </div>
  </div>
</div>
